export default function chkDisabled (role, state, selectorName) {
  if (role === 'Super Administrator') {
    if (
      selectorName === 'school' && !state.district ||
      selectorName === 'teacher' && !state.school ||
      selectorName === 'selectedClass' && !state.teacher
    ) {
      return true
    } else return false
  } else if (role === 'District Admin') {
    if (
      selectorName === 'teacher' && !state.school ||
      selectorName === 'selectedClass' && !state.teacher
    ) {
      return true
    } else return false
  } else if (role === 'School Admin') {
    if (selectorName === 'selectedClass' && !state.teacher) {
      return true
    } else return false
  } else return false
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/chkDisabled.js